import { CheckCircle, DoNotDisturbOn, Pending, ManageSearch } from '@mui/icons-material';
import { Alert, Divider, TextField, Typography, autocompleteClasses } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import AsyncAutocompleteBoxComponent from 'components/AsyncAutocompleteBoxComponent';
import RenderInput from 'components/renderInput';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';
import service from 'util/apiService';
import {
    clearSiteLocationAlerts,
    getSiteInfo,
    getSiteList,
    requestAccessAction,
    setSiteInfo,
    setSiteInfoSelected,
    setSiteInfoSuccess
} from '../ducks/actions';
import "../styles/site-location.scss";
import { getSiteInfoUrl, RequestAccessUrl, setSiteInfoUrl } from '../ducks/selectors';
import { RootState } from 'modules/cbre-flow-Common/reducers';
import Alerts from 'components/Alerts/Index';
import Button from "@mui/material/Button";
import { getClientsListUrl, getUserConfig, getUserInfoUrl } from "modules/cbre-flow-api-ducks";
import { getClientsList } from 'modules/cbre-flow-api-ducks/actions/clients';
import { getUserAccess } from 'modules/cbre-flow-api-ducks/selectors';
import { useSessionStorage } from 'components/useSessionStorage';

const moduleName = 'cbre-flow-site-location'
interface LocationSelectionProps {
    isInitialSiteSelection: boolean;
    closeSiteSelection?: any
}
interface SiteInfo {
    siteName: string;
    siteId: number;
    [key: string]: any;
    isLoading?: boolean;
}

const LocationSelection: React.FC<LocationSelectionProps> = (props) => {

    const { client, site, role, clients, isAnyAdmin } = useSelector(getUserAccess) || {};
    const showClientDropdown = isAnyAdmin || role?.translationKey === "CBRE_FS_TECHNICIANS";

    const isNoNeedRequestAccess = props.isInitialSiteSelection && (isAnyAdmin || role?.translationKey === "CLIENT_ACCESS_MANAGER");
    const onlySingleSiteSelection = props.isInitialSiteSelection && isNoNeedRequestAccess;

    // Your component code here
    const methods = useForm();
    const [options, setOptions] = useState<any[]>([]);
    const [clientsOptions, setClientsOptions] = useState<any[]>([]);
    const [clientsList, setClientsList] = useState<any[]>([]);
    const [text, setText] = useState('')
    const [clientsSearchText, setClientsSearchText] = useState('')
    const [loading, setLoading] = useState(false)
    const [selectedSite, setSelectedSite] = useState<any>(props.isInitialSiteSelection && !onlySingleSiteSelection ? [] : null)
    const [selectedClient, setSelectedClient] = useState(null)
    const dispatch = useDispatch();
    const history = useHistory();
    const siteUrl = useSelector(getSiteInfoUrl);
    const userUrl = useSelector(getUserInfoUrl);
    const updateSiteUrl = useSelector(setSiteInfoUrl);
    const clientListUrl = useSelector(getClientsListUrl);
    const requestAccessUrl = useSelector(RequestAccessUrl);
    const { clientCodes } = useSelector(({ auth }: any) => auth);
    const [isSiteListLoading, setIsSiteListLoading] = useState(false);
    const [isClientListLoading, setIsClientListLoading] = useState(false);

    const { defaultSiteLists, alert } = useSelector((state: RootState) => state["cbre-flow-site-location"] as unknown as { defaultSiteLists: any, alert: any })
    const loadOptions = (e: React.SyntheticEvent, value: string, mode: any) => {
        if (mode === "input") {
            service.get(`${siteUrl}?searchKey=${encodeURIComponent(value)}&pageSize=20&pageNumber=1&clientCode=${client.clientCode}`).then(({ data }) => {
                if (data?.recordsList) setOptions(data.recordsList)
                else setOptions([])
                setText(value);
            })
        }

    }

    const handleSiteList = (client: any) => {
        setIsSiteListLoading(true);
        dispatch(getSiteList({ apiUrl: `${siteUrl}?pageSize=100&pageNumber=1&clientCode=${client.clientCode}`, callback: () => setIsSiteListLoading(false) }))
    }



    const loadClientsOptions = (e: React.SyntheticEvent, value: string, mode: any) => {
        if (mode === "input" && value) {
            service.get(`${clientListUrl}?searchKey=${encodeURIComponent(value)}&pageSize=100&pageNumber=1`).then(({ data }) => {
                if (data?.recordsList) setClientsOptions(data.recordsList)
                else setClientsOptions([])
                setClientsSearchText(value);
            })
        }
    }

    useEffect(() => {
        if (client?.clientCode) {
            setSelectedClient(client);
            setClientsSearchText('');
            setSelectedSite(site?.siteName ? (props.isInitialSiteSelection && !onlySingleSiteSelection ? [site] : site) : (props.isInitialSiteSelection && !onlySingleSiteSelection ? [] : null));
            handleSiteList(client);
        } else if (clients?.length > 0) {
            setSelectedClient(clients[0]);
            setClientsSearchText('');
            setSelectedSite(site?.siteName ? (props.isInitialSiteSelection && !onlySingleSiteSelection ? [site] : site) : (props.isInitialSiteSelection && !onlySingleSiteSelection ? [] : null));
            handleSiteList(clients[0]);
        }
    }, [client, clients])

    useEffect(() => {
        setIsClientListLoading(true);
        dispatch(getClientsList({ apiUrl: clientListUrl }, (data: any) => {
            setClientsList(data?.recordsList?.filter(Boolean) || []);
            setIsClientListLoading(false);
        }));
    }, []);



    const RenderIcon = (option: any) => {
        if (option.accessStatus === 'PENDING') {
            return <Pending className="site-icon" style={{ color: '#8585E0' }} />
        } else if (option.accessLevel === "READ_ONLY" || option.accessLevel === "EDIT") {
            return <CheckCircle className="site-icon" style={{ color: '#50AF78' }} />

        } else if (option.accessStatus === 'NO_ACCESS') {
            return <DoNotDisturbOn className="site-icon" style={{ color: '#1A1A1A75' }} />
        }
    }

    const siteWithAccess = defaultSiteLists?.filter((site: SiteInfo) => site.accessStatus !== 'PENDING' && (site.accessLevel === "READ_ONLY" || site.accessLevel === "EDIT")) || [];
    const siteWithPendingApproval = defaultSiteLists?.filter((site: SiteInfo) => site.accessStatus === 'PENDING') || [];

    return (
        <div className={!props?.isInitialSiteSelection ? '' : ''}>
            {/* <Alerts alertState={alert?.type} handleRequestClose={handleRequestClose} message={alert?.message}/> */}

            {showClientDropdown && <><Autocomplete
                id="account-selection"
                className='site-selection-search mb-4'
                options={isClientListLoading ? [{ isLoading: true, clientName: 'Loading clients...' }] : clientsList}
                value={selectedClient}
                getOptionLabel={(option: any) => option?.clientName}
                getOptionDisabled={(option: any) => option?.isLoading}
                loading={isClientListLoading}
                renderOption={(props, option) => (
                    <li
                        {...props}
                        style={{
                            ...(option?.isLoading && {
                                pointerEvents: 'none',
                                opacity: 0.6,
                                fontStyle: 'italic',
                                cursor: 'not-allowed'
                            })
                        }}
                    >
                        {option?.isLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 0' }}>
                                <span>Loading clients...</span>
                            </div>
                        ) : (
                            option?.clientName
                        )}
                    </li>
                )}
                sx={{
                    width: '100%',
                    minWidth: props.isInitialSiteSelection ? '100%' : 350,
                    [`& .${autocompleteClasses.popupIndicator}`]: {
                        transform: "none"
                    }
                }}
                // onInputChange={loadClientsOptions}
                onChange={async (e, value, mode) => {
                    if (value?.isLoading) return; // Prevent selection of loading option
                    setSelectedClient(value);
                    setClientsSearchText('');
                    setSelectedSite(props.isInitialSiteSelection ? [] : null);
                    if (value) handleSiteList(value);
                }}
                renderInput={(params) => <TextField {...params}
                    label={<IntlMessages id="header.accountSelectionLabel" />} />}
                popupIcon={<ManageSearch />}
            />
                <Divider className='divider mb-4' />
            </>
            }
            <Autocomplete
                id="combo-box-demo"
                className='site-selection-search'
                options={isSiteListLoading ? [{ isLoading: true, siteName: 'Loading sites...' }] : defaultSiteLists}
                value={selectedSite as SiteInfo}
                multiple={props.isInitialSiteSelection && !onlySingleSiteSelection ? true : false}
                getOptionLabel={(option: any) => option?.siteName}
                getOptionDisabled={(option: any) => option.accessStatus === 'PENDING' || option?.isLoading}
                loading={isSiteListLoading}
                renderOption={(props, option) => (
                    <li
                        {...props}
                        style={{
                            ...(option?.isLoading && {
                                pointerEvents: 'none',
                                opacity: 0.6,
                                fontStyle: 'italic',
                                cursor: 'not-allowed'
                            })
                        }}
                    >
                        {option?.isLoading ? (
                            <div className="site-item d-flex align-items-center justify-content-between font-size-16 w-100">
                                <div className="site-name d-block">Loading sites...</div>
                                <div className="site-icon d-block">
                                    <div style={{
                                        width: '16px',
                                        height: '16px',
                                        border: '2px solid #ccc',
                                        borderTop: '2px solid #007bff',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite'
                                    }} />
                                </div>
                            </div>
                        ) : (
                            <div className="site-item d-flex align-items-center justify-content-between font-size-16 w-100">
                                <div className="site-name d-block">{option.siteName}</div>
                                <div className="site-icon d-block">
                                    {RenderIcon(option)}
                                </div>
                            </div>
                        )}
                    </li>
                )}
                sx={{
                    width: '100%',
                    minWidth: props.isInitialSiteSelection ? '100%' : 350,
                    [`& .${autocompleteClasses.popupIndicator}`]: {
                        transform: "none"
                    }
                }}
                slotProps={{
                    paper: {
                        sx: {
                            pt: 1,
                            pb: 1,
                        }
                    }
                }}
                // onInputChange={loadOptions}
                onChange={async (e, value, mode) => {
                    // Prevent selection of loading option
                    const prevSelectedInfo = { client, site }
                    if (!value) return;
                    // Check if value is an array and any item has isLoading, or if value itself has isLoading
                    if (Array.isArray(value)) {
                        if (value.some((v) => (v as SiteInfo).isLoading)) return;
                    } else if ((value as SiteInfo).isLoading) {
                        return;
                    }
                    if (mode === "selectOption" && !props?.isInitialSiteSelection) {
                        setSelectedSite(value);
                        const resp: any = await dispatch(setSiteInfo({ apiUrl: `${updateSiteUrl}?appCode=ELIS`, data: { ...value, clientCode: (selectedClient as any).clientCode }, userUrl }));
                        if (resp?.statusCode === 200 && typeof props.closeSiteSelection === "function") props.closeSiteSelection();
                    } else if (mode === "selectOption" && props?.isInitialSiteSelection) {
                        setSelectedSite(value);
                        // dispatch(setSiteInfoSelected(value))
                    } else if (mode !== "selectOption" && props?.isInitialSiteSelection) {
                        setSelectedSite(value);
                        dispatch(setSiteInfoSelected(''))
                    }
                    setText('')
                }}
                renderInput={(params) => <TextField {...params}
                    label={<IntlMessages id="header.siteSelectionLabel" />} />}
                popupIcon={<ManageSearch />}
            />
            {!props?.isInitialSiteSelection && siteWithAccess.length > 0 && <div>
                <Typography variant="h6" className="title d-flex mt-4 mb-2 font-size-12 font-weight-normal text-uppercase">
                    <IntlMessages id="header.sitesWithAccess" />
                </Typography>
                <ul className='pl-3'>
                    {siteWithAccess.map((site: SiteInfo) => (
                        <li key={site.siteName} className="site-item d-flex align-items-center justify-content-between font-size-16">
                            <div>
                                <span className="site-name">{site.siteName}</span> •
                                <Typography variant="body2" className="site-description">
                                    {site.siteDescription}
                                </Typography>
                            </div>
                            <div>
                                <CheckCircle className="site-icon" style={{ color: '#50AF78' }} />
                            </div>
                        </li>
                    ))}
                </ul>
            </div>}
            {!props?.isInitialSiteSelection && siteWithPendingApproval.length > 0 && <div>
                <Typography variant="h6" className="title d-flex mt-4 mb-2 font-size-12 font-weight-normal text-uppercase">
                    <IntlMessages id="header.sitesWithPendingApproval" />
                </Typography>
                <ul className='pl-3'>
                    {siteWithPendingApproval.map((site: SiteInfo) => (
                        <li key={site.siteId} className="site-item d-flex align-items-center justify-content-between font-size-16">
                            <div>
                                <span className="site-name">{site.siteName}</span> •
                                <Typography variant="body2" className="site-description">
                                    {site.siteDescription}
                                </Typography>
                            </div>
                            <div>
                                <Pending className="site-icon" style={{ color: '#8585E0' }} />
                            </div>
                        </li>
                    ))}
                </ul>
            </div>}
            {props?.isInitialSiteSelection && (
                <div className="continueButtonContainer">
                    <Button
                        variant="contained"
                        color="primary"
                        className={((Array.isArray(selectedSite) ? selectedSite.length > 0 : (selectedSite as SiteInfo)?.siteName) && !loading) ? "active" : "disabled"}
                        disabled={(!((Array.isArray(selectedSite) ? selectedSite.length > 0 : (selectedSite as SiteInfo)?.siteName)) || loading)}
                        onClick={async () => {
                            setLoading(true);

                            try {

                                if (isNoNeedRequestAccess) {
                                    if (Array.isArray(selectedSite) ? selectedSite.length > 0 : (selectedSite as SiteInfo)?.siteName) {
                                        const siteData = Array.isArray(selectedSite) ? selectedSite[0] : selectedSite;
                                        await dispatch(setSiteInfo({
                                            apiUrl: `${updateSiteUrl}?appCode=ELIS`, userUrl, redirectUrl: '/elis/dashboard', history, callback: () => {
                                                setLoading(false);
                                                setSiteInfoSelected(siteData);
                                            }, data: { ...siteData, clientCode: (selectedClient as any).clientCode }
                                        }))

                                    }
                                    return;
                                }

                                const requestActionPayload = {
                                    siteRequests: Array.isArray(selectedSite) ? selectedSite.map((site: SiteInfo) => ({
                                        site: site.site,
                                    })) : [],
                                    requestReason: "",
                                    appCode: "ELIS",
                                    clientCode: (selectedClient as any).clientCode
                                }

                                await dispatch(requestAccessAction({
                                    apiUrl: requestAccessUrl, data: requestActionPayload, callback: () => {
                                        if (Array.isArray(selectedSite) ? selectedSite.length > 0 : (selectedSite as SiteInfo)?.siteName) {
                                            const siteData = Array.isArray(selectedSite) ? selectedSite[0] : selectedSite;
                                            dispatch(setSiteInfo({
                                                apiUrl: `${updateSiteUrl}?appCode=ELIS`, userUrl, redirectUrl: '/elis/dashboard', history, callback: () => {
                                                    setLoading(false);
                                                    setSiteInfoSelected(siteData);
                                                }, data: { ...siteData, clientCode: (selectedClient as any).clientCode }
                                            }))

                                        }
                                    }
                                }));


                            } catch (err) {
                                //ignore
                                setLoading(false)
                            }



                        }}
                    >
                        {onlySingleSiteSelection ? "Continue" : "Request Access"}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default LocationSelection;